<app-dialog
	[titleButton]="getButtonTitle()"
	secTitleButton=""
	[modalTitle]="title"
	[secButton]="false"
	[asAlert]="true"
	[noMargins]="true"
	(dialogSave)="closeModal(canRetry)"
	(dialogClose)="closeModal()"
>
	<ul>
		<li *ngFor="let msg of messages; trackBy: trackByFn">
			<p>{{ msg }}</p>
		</li>
	</ul>
</app-dialog>
